<div class="page-body">

    <h2 class="center-text">CCP Configuration</h2>

    <mat-tab-group>
        <mat-tab label="CCP Configuration">
            <div class="flex-container space-center">
                <select class="left custom-select" [(ngModel)]="lobSelect">
                    <option class="custom-option" selected hidden ngValue="">Select Line of Business</option>
                    <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]">{{lob[0]}}</option>
                </select>
            </div>
        
            <div id="tableContainer" *ngIf="lobSelect != ''">
                <app-response-text
                    [lambdaMessage]="lambdaMessage"
                    [lambdaError]="lambdaError">
                </app-response-text>
        

                <div fxLayout="row" fxLayoutAlign="center"> 
                    <app-mat-data-grid 
                        class="page-data-grid"
                        [formValid]="formValid"
                        [(dataSource)]="data[lobSelect]" 
                        [displayedColumns]="['featureName', 'active']"
                        [columnNames]="['Flag', 'Active']"
                        [editDefinition]="{'featureName': flag, 'active': active}"
                        [buttonConfig]="{
                            create: {show: true},
                            edit: {show: true},
                            delete: {show: true}
                        }"
                        [objectBluePrint]="bluePrint"
                        (buttonClick)="handleNewItem($event);">
                    </app-mat-data-grid>
                    <!-- flag name column -->
                    <ng-template #flag let-item>
                        <select class="left small" [(ngModel)]="item.featureName" (ngModelChange)="validate(item);">
                            <option *ngFor = "let flag of flags" [ngValue]="flag.name" [hidden]="(isFlagInUse(flag) && flag.name != item.featureName)">{{flag.name}}</option>
                        </select>
                    </ng-template>

                    <!-- active column -->
                    <ng-template #active let-item>
                        <select class="left small" [(ngModel)]="item.active" (ngModelChange)="validate(item);">
                            <option [ngValue]="'true'">True</option>
                            <option [ngValue]="'false'">False</option>
                        </select>
                    </ng-template>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Config Flag Definition">
            <app-response-text
                [lambdaMessage]="lambdaMessage"
                [lambdaError]="lambdaError">
            </app-response-text>

            <div fxLayout="row" fxLayoutAlign="center"> 
                <app-mat-data-grid 
                    class="page-data-grid"
                    [formValid]="flagFormValid"
                    [(dataSource)]="flags" 
                    [displayedColumns]="['name', 'description']"
                    [columnNames]="['Flag', 'Description']"
                    [editDefinition]="{'name': name, 'description': description}"
                    [buttonConfig]="{
                        create: {show: true},
                        edit: {show: true},
                        delete: {show: true}
                    }"
                    [objectBluePrint]="flagBluePrint"
                    (buttonClick)="handleNewItem($event);">
                </app-mat-data-grid>
                <!-- flag name column -->
                <ng-template #name let-item>
                    <input class="small" type="text" [(ngModel)]="item.name" (ngModelChange)="validateFlag(item);">
                </ng-template>

                <!-- description column -->
                <ng-template #description let-item>
                    <input type="text" class="small" [(ngModel)]="item.description" (ngModelChange)="validateFlag(item);">
                </ng-template>
            </div>
        </mat-tab>
    </mat-tab-group>
   

</div>